import {
    PLANOGRAMS_UPLOAD_LIST_LOADING,
    PLANOGRAMS_UPLOAD_LIST_LOADING_DONE,
    PLANOGRAMS_UPLOAD_LIST,
} from '../../actions';

const INITIAL_STATE = {
    loading: false,
    content: [],
    totalElements: 0,
    totalPages: 0,
    size: 20,
    number: 0,
};

const getPlanogramUploadList = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PLANOGRAMS_UPLOAD_LIST:
            return {
                ...state,
                ...action.data,
                loading: false,
            };
        case PLANOGRAMS_UPLOAD_LIST_LOADING:
            return { ...state, loading: true };
        case PLANOGRAMS_UPLOAD_LIST_LOADING_DONE:
            return { ...state, loading: false };
        default:
            return state;
    }
};
export default getPlanogramUploadList;
